import { useSelector, useDispatch } from 'react-redux'

import { userActions, dashboardActions, cartActions, orderActions, pubsubActions } from '@redux'

export const useUserRedux = () => {
    const dispatch = useDispatch()
    const { isLoading, error, profile, diningMethod, tableId } = useSelector(state => state.user)

    return {
        isLoading,
        error,
        profile,
        diningMethod,
        tableId,
        clearUser: () => dispatch(userActions.clearUser()),
        fetchProfile: token => dispatch(userActions.fetchProfile(token)),
        setDiningMethod: method => dispatch(userActions.setDiningMethod(method)),
        setTableId: id => dispatch(userActions.setTableId(id)),
    }
}

export const useDashboardRedux = () => {
    const dispatch = useDispatch()
    const {
        isLoading,
        error,
        menus,
        filteredMenus,
        stalls,
        tables,
        cashRegisters,
        cafeGroups,
        updatedInventoryStatus,
        categories,
        selectedCategory,
        selectedProduct,
        searchValue,
        selectedGroupId,
    } = useSelector(state => state.dashboard)

    return {
        isLoading,
        error,
        menus,
        filteredMenus,
        stalls,
        tables,
        cashRegisters,
        cafeGroups,
        updatedInventoryStatus,
        categories,
        selectedCategory,
        selectedProduct,
        searchValue,
        selectedGroupId,
        fetchMenus: () => dispatch(dashboardActions.fetchMenus()),
        fetchCafeConfig: () => dispatch(dashboardActions.fetchCafeConfig()),
        fetchCafeCashRegisters: () => dispatch(dashboardActions.fetchCafeCashRegisters()),
        fetchCafeGroups: () => dispatch(dashboardActions.fetchCafeGroups()),

        setSelectedCategory: category => dispatch(dashboardActions.setSelectedCategory(category)),
        setSelectedProduct: product => dispatch(dashboardActions.setSelectedProduct(product)),
        setSearchValue: value => dispatch(dashboardActions.setSearchValue(value)),
        setSelectedGroupId: id => dispatch(dashboardActions.setSelectedGroupId(id)),
    }
}

export const useCartRedux = () => {
    const dispatch = useDispatch()
    const {
        items,
        tempItem,
        isConfirmPopupOpen,
        isUnsavedChanges,
        inventoryChanges,
        clientRequestId,
        assistantInfo,
        assistantCarts,
    } = useSelector(state => state.cart)

    return {
        items,
        tempItem,
        isConfirmPopupOpen,
        isUnsavedChanges,
        inventoryChanges,
        clientRequestId,
        assistantInfo,
        assistantCarts,
        addItem: item => dispatch(cartActions.addItem(item)),
        replaceItem: () => dispatch(cartActions.replaceItem()),
        cancelReplace: () => dispatch(cartActions.cancelReplace()),
        removeItem: idx => dispatch(cartActions.removeItem(idx)),
        removeVariant: (idx, variantId) => dispatch(cartActions.removeVariant({ idx, variantId })),
        clearCart: () => dispatch(cartActions.clearCart()),
        plusQuantity: (idx, variantId) => dispatch(cartActions.plusQuantity({ idx, variantId })),
        minusQuantity: (idx, variantId) => dispatch(cartActions.minusQuantity({ idx, variantId })),
        checkInventoryStatus: ids => dispatch(cartActions.checkInventoryStatus(ids)),
        initClientRequestId: () => dispatch(cartActions.initClientRequestId()),
        clearClientRequestId: () => dispatch(cartActions.clearClientRequestId()),
        clearAssistantData: () => dispatch(cartActions.clearAssistantData()),
    }
}

export const useOrderRedux = () => {
    const dispatch = useDispatch()
    const { isLoading, error, completeOrder, searchedOrder } = useSelector(state => state.order)

    return {
        isLoading,
        error,
        completeOrder,
        searchedOrder,
        setCompleteOrder: order => dispatch(orderActions.setCompleteOrder(order)),
        setSearchedOrder: order => dispatch(orderActions.setSearchedOrder(order)),
        submitOrder: input => dispatch(orderActions.submitOrder(input)),
        fetchOrderByNumber: number => dispatch(orderActions.fetchOrderByNumber(number)),
        fetchOrderById: orderId => dispatch(orderActions.fetchOrderById(orderId)),
        cancelProduct: productId => dispatch(orderActions.cancelProduct(productId)),
    }
}

export const usePubsubRedux = () => {
    const dispatch = useDispatch()
    const { status, error, activeGroupId } = useSelector(state => state.pubsub)

    return {
        status,
        error,
        activeGroupId,
        setPubsubStatus: s => dispatch(pubsubActions.setStatus(s)),
        setPubsubError: e => dispatch(pubsubActions.setError(e)),
        setActiveGroupId: id => dispatch(pubsubActions.setActiveGroupId(id)),
        clearActiveGroupId: () => dispatch(pubsubActions.clearActiveGroupId()),
    }
}
